export const getRecipientType = (itemType: string) => {
  switch (itemType) {
    case 'company_user':
      return 'companyUser'
  }
  return itemType
}
